module.exports = __webpack_public_path__ + "public/img/ks_pic.955137f8.gif";